module.exports = __webpack_public_path__ + "static/media/04_after.cc51531c.jpg";